"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Team = void 0;
const ModelCommon_1 = require("./ModelCommon");
const typeName = 'Team';
class Team extends ModelCommon_1.ModelCommon {
    constructor(ob) {
        super(ob.type || typeName, ob);
        this.members = ob.members ?? [];
    }
}
exports.Team = Team;
